var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
var ButtonGroup_1 = __importDefault(require("./ButtonGroup"));
exports.ButtonGroup = ButtonGroup_1.default;
exports.default = ButtonGroup_1.default;
//# sourceMappingURL=index.js.map